<div fxHide.gt-sm>
    <mat-toolbar>
      <div fxLayout="row" fxLayoutAlign="space-around center">
        <button mat-icon-button (click)="onToggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <span>Website Administrator</span>
      </div>
    </mat-toolbar>
  </div>